import React, {Component} from 'react';
import {connect} from 'react-redux';
import MyCheckbox from '../layout/Checkbox';
import Collapsible from '../layout/Collapsible';
import AskIslamFilters from './AskIslamFilters';
import { searchAction } from '../../store/actions/searchActions';
import {
    toggleModalAction,
    addMtmIndexAction,
    removeMtmIndexAction,
    addMtmIndexesAction,
    removeMtmIndexesAction,
} from '../../store/actions/filtersActions';

export const MTM_SOURCES = [
    {
        id: 'this_week_with_huzoor',
        label: 'This Week With Huzoor',
        yearStart: 2019,
        filterIdPrefix: 'huzoorWeekly',
        yearsField: 'thisWeekWithHuzoorYears',
        monthsField: 'thisWeekWithHuzoorMonths',
        languagesField: 'thisWeekWithHuzoorLanguages',
    },
    {
        id: 'beacon_of_guidance',
        label: 'Beacon of Guidance',
        yearStart: 2022,
        filterIdPrefix: 'beaconOfGuidance',
        yearsField: 'beaconOfGuidanceYears',
        monthsField: 'beaconOfGuidanceMonths',
        languagesField: 'beaconOfGuidanceLanguages',
    },
];

export class MTMMaterialFilters extends Component {
    constructor(props) {
        super(props);
        this.applyFilters = this.applyFilters.bind(this);
        this.handleSourceCheckbox = this.handleSourceCheckbox.bind(this);
        this.selectAllSources = this.selectAllSources.bind(this);
    }

    handleSourceCheckbox(e) {
        const source = e.target.id.replace('mtm-source-', '');
        if (e.target.checked) {
            this.props.addMtmIndex(source);
        } else {
            this.props.removeMtmIndex(source);
        }
    }

    selectAllSources(e) {
        if (e.target.checked) {
            this.props.addMtmIndexes(MTM_SOURCES.map(source => source.id));
        } else {
            this.props.removeMtmIndexes();
        }
    }

    applyFilters() {
        this.props.performSearch(
            document.querySelector('#search_field').value,
            this.props.filters
        );
        this.props.toggleModal(false);
    }

    render() {
        const selectedIndexes = this.props.filters.mtmIndexes || [];
        const allSelected = selectedIndexes.length === MTM_SOURCES.length;
        const currentYear = new Date().getFullYear();

        return <div>
            <span><strong>Select MTA Material</strong></span>&nbsp;
            <MyCheckbox
                checked={allSelected}
                onChange={this.selectAllSources}
                label="Select all"
                id="mtm-select-all"
            />
            <div className="display-flex" style={{flexWrap: 'wrap'}}>
                {MTM_SOURCES.map(source => <div
                    key={source.id}
                    className="width-content margin-left-40p"
                    style={{minWidth: '240px'}}
                >
                    <MyCheckbox
                        checked={selectedIndexes.includes(source.id)}
                        onChange={this.handleSourceCheckbox}
                        label={source.label}
                        id={`mtm-source-${source.id}`}
                    />
                </div>)}
            </div>

            {MTM_SOURCES
                .filter(source => selectedIndexes.includes(source.id))
                .map(source => <Collapsible
                    key={`${source.id}-filters`}
                    defaultExpanded={true}
                    header={`${source.label} Filters`}
                    body={<AskIslamFilters
                        yearStart={source.yearStart}
                        yearEnd={currentYear}
                        filterIdPrefix={source.filterIdPrefix}
                        yearsField={source.yearsField}
                        monthsField={source.monthsField}
                        languagesField={source.languagesField}
                        showLanguageFilter={true}
                        showApplyButton={false}
                    />}
                />)}

            <div className="apply-filters-container">
                <button
                    onClick={this.applyFilters}
                    className="btn apply-filters-btn margin-auto display-block"
                >
                    Apply and Search
                </button>
            </div>
        </div>;
    }
}

const mapStateToProps = state => ({
    filters: state.filters,
});

const mapDispatchToProps = dispatch => ({
    performSearch: (term, filters) => dispatch(searchAction(term, 0, filters)),
    toggleModal: value => dispatch(toggleModalAction(value)),
    addMtmIndex: index => dispatch(addMtmIndexAction(index)),
    removeMtmIndex: index => dispatch(removeMtmIndexAction(index)),
    addMtmIndexes: indexes => dispatch(addMtmIndexesAction(indexes)),
    removeMtmIndexes: () => dispatch(removeMtmIndexesAction()),
});

export default connect(mapStateToProps, mapDispatchToProps)(MTMMaterialFilters);
